export default __webpack_public_path__ + "static/media/Amazon-DynamoDB.48de546a.svg";